import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Link } from "react-router-dom";

import styled from "styled-components";

// import about_left from "../../assets/images/ab_im.jpg";
import about_left from "../../assets/images/main_23.jpg";
import arrow1 from "../../assets/images/arrow_1.svg";
import arrow2 from "../../assets/images/arrow_2.svg";
import left_boxes_images from "../../assets/images/left_boxes_images_2.svg";
// import mmc_left from "../../assets/images/mmc_left_2.svg";
import mmc_left from "../../assets/images/birds_2.svg";
import mmc_right from "../../assets/images/birds_1.svg";
import tg_button from "../../assets/images/tg_button.svg";
import top_img from "../../assets/images/top_ccc_kaz.jpg";
import InteractiveLandingMap from "../tools/InteractiveLandingMap";
import SpinningCircles from "../tools/spinning-circles";
import { Button, Container, Frame, Logo, Row } from "../ui-kit/styled-templates";

const MainLandingPage = () => {
    const { t } = useTranslation();

    useEffect(() => {
        // scroll to top after render and after article loaded
        try{
            setTimeout(() => {
                console.log('scroll to top!!!');
                window.scrollTo({
                    top: 0,
                    behavior: 'auto'
                });
                const element = document.getElementById("header_logo");
                if (element) {
                    element.scrollIntoView({
                        behavior: "auto", // Optional for smooth scrolling
                        block: "start",     // Aligns the element at the top
                    });
                }
            }, 100);
        }catch(exc){

        }
    }, []);

    return (
        <OuterWrapper>
            {/* <TopSection>
                <Carousel showThumbs={false} showIndicators={true} dynamicHeight={false} autoPlay={true} interval={4000}>
                    {[top1, top2, top3, top4, top5, top7, top8, top9, top10, top11].map((x, i) => {
                        return (
                            <SlideItem src={x} key={i}>
                                <img src={x} />
                            </SlideItem>
                        );
                    })}
                </Carousel>
                <TopSectionInner>
                    <WhiteHeading>Путешествуй по России</WhiteHeading>
                </TopSectionInner>
            </TopSection> */}
            <Frame extra="width: 100%; margin-top: 15px;">
                <Container
                    extra="flex-direction: row; justify-content: space-between; > * { width: 50%; }; }; @media (max-width: 991px) { flex-direction: column; > * { width: 100%; }; };">
                    <Frame extra="align-items: flex-start; padding-left: 20px; padding-right: 10px;">
                        <h1>{t("7ezi3lemkk")}</h1>
                        <AboutP>{t("ztykgqc3p4g")}</AboutP>
                        <Row
                            className={"top_buttons_placeholder"}
                            extra="gap: 32px; @media (max-width: 991px) { flex-direction: column; * { width: 100%; }; };"
                        >
                            <Link to="/search">
                                <Button>{t("ehvze7dy3wu")}</Button>
                            </Link>
                            <Link to="/registration/student">
                                <Button variant="outlined">{t("zy8230lizbi")} </Button>
                            </Link>
                        </Row>
                    </Frame>
                    <SpinningCircles
                        extra="height: 600px; margin-top: 15px; @media (max-width: 991px) { display: none; };"
                        rings={3}
                        contentArray={[
                            <FlyingImage src="flying_image_1" />,
                            <FlyingImage src="flying_image_2" />,
                            <FlyingImage src="iiim" />
                        ]}
                    >
                        <Logo src="image_circle_01.png"
                              extra="height: 25%; @media (max-width: 991px) { height: 150px; };" />
                    </SpinningCircles>
                </Container>
            </Frame>

            <HowSection>
                <HowHeading>{t("2pujqjjxqcf")}</HowHeading>

                <StepsPlaceholder>
                    {[
                        {
                            label: "1",
                            subLabel: t("v3otpyg9w2"),
                            description: t("d62ivkxyof"),
                            arrow: arrow1
                        },
                        {
                            label: "2",
                            subLabel: t("298inprrl1v"),
                            description: t("9hboc25vrvb"),
                            arrow: arrow1
                        },
                        {
                            label: "3",
                            subLabel: t("gd4ad25fat"),
                            description: t("dqyid2g94si")
                        }
                    ].map((a, i) => {
                        let { label, subLabel, description, arrow } = a;
                        return (
                            <React.Fragment key={i}>
                                <HowBox>
                                    <HowTop>{label}</HowTop>
                                    <HowName>{subLabel}</HowName>
                                    <div
                                        style={{
                                            height: 4,
                                            width: 90,
                                            backgroundColor: "#02BF89",

                                            borderRadius: 19,
                                            marginTop: 15,
                                            marginBottom: 15
                                        }}
                                    ></div>
                                    <HowDesc dangerouslySetInnerHTML={{__html: `${description}`.replace(/\n/g, '<br/>')}} ></HowDesc>
                                </HowBox>
                                {arrow && <NextArrow src={arrow} />}
                            </React.Fragment>
                        );
                    })}
                </StepsPlaceholder>
            </HowSection>

            {/*<StudSection>*/}
            {/*    <WrapperBox>*/}
            {/*        <StudInner>*/}
            {/*            <StudLeft>*/}
            {/*                <StudLeftBoxesPlaceholder>*/}
            {/*                    <img style={{ width: 130 }} src={left_boxes_images} />*/}
            {/*                </StudLeftBoxesPlaceholder>*/}
            {/*                <StudHeading>*/}
            {/*                    {t("bwkvx2pvntc")}*/}
            {/*                    <br />*/}
            {/*                    <RedSpan>{t("hxvryovjn5")}</RedSpan>*/}
            {/*                </StudHeading>*/}
            {/*                <StudP>{t("lf12z5uznt")}</StudP>*/}
            {/*                <StudButtonsPlaceholder>*/}
            {/*                    <Link to="/search">*/}
            {/*                        <Button type="submit" className={"start_button"} background="blue" extra={``}>*/}
            {/*                            {t("9rw4aps3wmk")}*/}
            {/*                        </Button>*/}
            {/*                    </Link>*/}
            {/*                    <Link to="/registration/student">*/}
            {/*                        <Button variant="outlined" className={"signup_button"} extra={`margin-left: 20px;`}>*/}
            {/*                            {t("ubrdnyibd6")}*/}
            {/*                        </Button>*/}
            {/*                    </Link>*/}
            {/*                </StudButtonsPlaceholder>*/}
            {/*            </StudLeft>*/}
            {/*            <InterMapWrapper>*/}
            {/*                /!*<InteractiveMap />*!/*/}
            {/*                <InteractiveLandingMap />*/}
            {/*            </InterMapWrapper>*/}
            {/*            /!* <StudRightImage src={stud_im} /> *!/*/}
            {/*        </StudInner>*/}
            {/*    </WrapperBox>*/}
            {/*</StudSection>*/}

            <MMCSection>
                <MMCLeftImg src={mmc_left} />
                <MMCRightImg src={mmc_right} />
                <WrapperBox>
                    <MmcInnerPlaceholder>
                        <MmcLeft>
                            <MMCHeading>{t("rome23w2xrn")}</MMCHeading>
                            <MMCP>{t("m7rgqwtl9kj")}</MMCP>
                        </MmcLeft>
                        <a href="https://t.me/studturism">
                            <MmcRight>
                                <TeleSpan>Telegram</TeleSpan>
                                <TeleImg style={{ cursor: "pointer" }} src={tg_button} />
                            </MmcRight>
                        </a>
                    </MmcInnerPlaceholder>
                </WrapperBox>
            </MMCSection>

            <AboutSection>
                <WrapperBox>
                    <AboutSectionInner>
                        <AboutLeft>
                            <AboutLeftImg src={about_left} />
                        </AboutLeft>
                        <AboutRight>
                            <AboutHeading>{t("gdtjske6kqh")}</AboutHeading>
                            <AboutP>{t("amacbsgl5gv")}</AboutP>
                            <AboutP>{t("fktm1892bfc")}</AboutP>
                            <AboutP>{t("tcqwo46jf7")}</AboutP>
                            <StudButtonsPlaceholder>
                                <Link to="/search">
                                    <Button type="submit" className={"start_button"} background="blue" extra={``}>
                                        {t("1orurvap1lv")}
                                    </Button>
                                </Link>
                                <Link to="/registration/student">
                                    <Button className={"signup_button"} variant="outlined" extra={`margin-left: 20px;`}>
                                        {t("1c4s4gazl89")}
                                    </Button>
                                </Link>
                            </StudButtonsPlaceholder>
                        </AboutRight>
                    </AboutSectionInner>
                </WrapperBox>
            </AboutSection>

            {/*<Link to={'/'}>To home</Link>*/}
            {/*<Link to={'/login'}>To login</Link>*/}
        </OuterWrapper>
    );
};

const InterMapWrapper = styled.div`
  @media (max-width: 820px) {
    height: 60vh;
    margin-top: -5vh;
  }
`;

const FlyingImage = styled(Frame)`
  width: 150px;
  height: 150px;
  background: url("${({ src }) => require(`../../assets/images/${src}.png`)}") no-repeat center center / contain;
  /* background: red; */
`;

const SlideItem = styled.div`
  width: 100vw;
  height: 100%;
  background-image: ${(props) => `url(${props.src})`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const TeleImg = styled.img`
  height: 70px;
  @media (max-width: 800px) {
    height: 50px;
  }
`;

const TeleSpan = styled.div`
  font-size: 42px;
  color: white;
  margin-right: 20px;
  font-family: "Noto Sans", sans-serif;
  //font-weight: bold;
  cursor: pointer;
  text-decoration: underline;

  :hover {
    opacity: 0.85;
  }

  @media (max-width: 800px) {
    font-size: 24px;
  }
`;

const AboutP = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  color: #212529;
  margin-bottom: 20px;
  @media (max-width: 820px) {
    font-size: 20px;
    line-height: 28px;
  }
`;

const AboutSectionInner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 800px) {
    display: block;
    .signup_button {
      margin-left: 0px !important;
      margin-top: 10px;
    }
  }

 
`;

const AboutHeading = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 50px;
  line-height: 56px;
  letter-spacing: 0.01em;
  color: #212121;
  margin-bottom: 40px;
  @media (max-width: 820px) {
    font-size: 24px;
    line-height: 32px;
  }
`;

const AboutLeft = styled.div`
  @media (max-width: 820px) {
    font-size: 20px;
    line-height: 28px;
  }
  @media (max-width: 1020px) {
    font-size: 20px;
    line-height: 28px;
    padding: 15px;
  }
  @media (max-width: 720px) {
    padding: 0px !important;
    margin-top: -20px;
  }


`;

const AboutLeftImg = styled.img`
  height: 540px;
  margin-left: -80px;
  max-width: initial !important;

  @media (max-width: 1280px) {
    margin-left: 0px;
    max-width: 90%;
  }
  
  @media (max-width: 1180px) {
    margin-left: 0px;
    //width: 100%;
    //height: auto;
    display: none;
  }
  
  @media (max-width: 720px) {
    margin-left: 0px;
    width: 100%;
    height: auto;
    display: block;
  }
  
  
  
`;

const AboutRight = styled.div`
  margin-left: 120px;
  @media (max-width: 1280px) {
    margin-left: 20px;
    padding: 15px;
    padding-top: 40px;
    font-size: 20px;
    line-height: 28px;
    padding-right: 20px;
  }
  @media (max-width: 800px) {
    margin-left: 0px;
    padding: 15px;
    padding-top: 40px;
    font-size: 20px;
    line-height: 28px;
  }
`;

const AboutSection = styled.div`
  margin-top: 90px;
  margin-bottom: 90px;
  @media (max-width: 820px) {
    padding-top: 10px;
    margin-top: 10px;
  }
`;

const MmcLeft = styled.div`
  flex: 1;
`;

const MMCP = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  color: #ffffff;
  @media (max-width: 820px) {
    font-size: 20px;
    line-height: 28px;
  }
`;

const MMCHeading = styled.div`
  margin-bottom: 40px;
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 56px;
  letter-spacing: 0.01em;
  color: #ffffff;
  @media (max-width: 820px) {
    font-size: 24px;
    line-height: 32px;
  }
`;

const MmcRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 40px;
  padding-right: 20px;
  @media (max-width: 800px) {
    margin-left: 0px;
    margin-top: 30px;
  }
`;

const MmcInnerPlaceholder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  z-index: 2;
  @media (max-width: 720px) {
    display: block;
  }
`;

const MMCLeftImg = styled.img`
  position: absolute;
  top: 0px;
  left: 0px;
  opacity: 0.2;
  height: 100%;
  @media (max-width: 1680px) {
    display: none;
  }
`;

const MMCRightImg = styled.img`
  position: absolute;
  top: 0px;
  opacity: 0.5;
  right: 0px;
  height: 100%;
  @media (max-width: 1680px) {
    display: none;
  }
`;

const MMCSection = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  //background: #00a19a;
  background: #02BF89;
  padding: 40px;
  margin-top: 60px;
  margin-bottom: 60px;
  @media(max-width: 800px){
    margin-top: 10px;
    margin-bottom: 10px;
    padding-top: 20px;
    padding-bottom: 20px;
  }
`;

const StudButtonsPlaceholder = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 40px;
  @media (max-width: 800px) {
    flex-direction: column;
    align-items: center;
  }
`;

const StudP = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  color: #212529;
  margin-top: 40px;
  @media (max-width: 820px) {
    font-size: 20px;
    line-height: 28px;
  }
`;

const WrapperBox = styled.div`
  width: 1400px;
  margin: 0 auto;
  @media (max-width: 1400px) {
    width: 100%;
  }
`;

const StudSection = styled.div``;

const StudHeading = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 56px;
  letter-spacing: 0.01em;
  color: #212121;
`;

const RedSpan = styled.div`
  font-family: "Noto Sans", sans-serif;
  color: #ef4058;
`;

const StudLeft = styled.div`
  width: 620px;
  padding-right: 40px;
  margin-bottom: 40px;
  position: relative;
  margin-right: 40px;
  @media (max-width: 800px) {
    padding: 10px;
    box-sizing: border-box;
    width: 100%;
  }
`;

const StudLeftBoxesPlaceholder = styled.div`
  position: absolute;
  top: -30px;
  left: -160px;
  @media (max-width: 800px) {
    display: none;
  }
`;

const StudRightImage = styled.img`
  //height: 620px;
  width: 802px;
  border-radius: 12px;
  @media (max-width: 800px) {
    width: 100%;
    height: auto;
    box-sizing: border-box;
  }
`;

const StudInner = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 800px) {
    display: block;
    .signup_button {
      margin-left: 0px !important;
      margin-top: 10px;
    }
  }
`;

const NextArrow = styled.img`
  height: 50px;
  margin-left: 50px;
  margin-right: 50px;
  margin-top: 60px;
  @media (max-width: 800px) {
    display: none;
  }
`;

const HowDesc = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  //color: #212529;
  opacity: 0.5;
  width: 140px;
  //color: #723DD2;
  color: #723DD3;
`;

const HowTop = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 96px;
  line-height: 96px;
  //color: #00a19a;
  color: #02BF89;

`;

const HowName = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 27px;
  color: #212121;
`;

const HowBox = styled.div`
  @media (max-width: 800px) {
    margin-bottom: 50px;
  }
`;

const HowSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 60px;
  padding-bottom: 60px;
  @media(max-width: 800px){
    //padding-top: 20px;
    padding-bottom: 0px;
  }
`;

const StepsPlaceholder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 60px;
  margin-bottom: 40px;
  width: 820px;
  @media (max-width: 800px) {
    width: 100%;
    box-sizing: border-box;
    flex-direction: column;
    align-items: flex-start;
    max-width: 87vw;
  }
`;

const HowHeading = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 40px;
  line-height: 56px;
  letter-spacing: 0.01em;
  color: #212121;
  text-align: center;
  @media (max-width: 800px) {
    font-size: 25px !important;
    line-height: 46px !important;
    text-align: left !important;
  }
`;

const WhiteHeading = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 80px;
  line-height: 80px;
  color: white;
  margin-bottom: 40px;
  @media (max-width: 800px) {
    font-size: 40px;
    line-height: 45px;
    text-align: center;
    letter-spacing: 0.01em;
    color: #ffffff;
  }
`;

const TopSectionInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 68.21%, rgba(0, 0, 0, 0.4) 83.9%);
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
`;

const TopSection = styled.div`
  //height: 615px;
  height: 33vw;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
    //background-image: url(${top_img});
  @media (max-width: 800px) {
    //height: max(280px, 50vw);
    min-height: 150px;
  }
`;

const OuterWrapper = styled.div`
  width: 100%;
  background: white;
  box-sizing: border-box;
  padding-bottom: 40px;
`;

const Wrapper = styled.div`
  text-align: left;
  box-sizing: border-box;
  width: 1400px;
  margin: 0 auto;
  @media (max-width: 1400px) {
    width: 100%;
  }
`;

export default MainLandingPage;
